export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey[1] === 'SPAN':
    case splitKey[1] === 'LOCATE':
      return splitKey[0]

    case splitKey.length === 2:
      return splitKey[1]

    case splitKey.length === 4:
      return `${splitKey[2]}${splitKey[3]}`

    default:
      return splitKey[2]
  }
}
